import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import getPageTitle from "@/utils/get-page-title";
import api from "./api";
import { resetRouter, dynamicRoutes } from "@/router";
import { routerControl, isInclude, havaPermission } from "router-control";
NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login", "/resetPassword"]; // no redirect whitelist
// 2026-10-25：守卫权限接口 60s 节流时间戳
let permissionLastFetch = 0;

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const hasToken = store.getters.token;
  if (hasToken) {
    // 2026-10-25 修复（请求风暴，与 factory 同款）：守卫顶部权限/到期接口原先每次
    // 路由导航都无条件重发，无权限账号被 next(false) 弹回后循环放大（实测 13req/s）。
    // 60s 节流（权限变更重新登录即可刷新）。
    if (Date.now() - permissionLastFetch > 60000) {
    permissionLastFetch = Date.now();
    api.user
      .accountPermission()
      .then((res) => {
        let permissionListMap = {};
        res.forEach((item) => {
          permissionListMap[item.applicationCode] = item.resourceMenuList;
        });
        localStorage.setItem(
          "permission_list",
          JSON.stringify(permissionListMap)
        );
        localStorage.setItem("permission_list_maomao", JSON.stringify(res));
      })
      .catch((error) => {
        // 2026-10-18 修复：beforeEach 作用域内不存在 reject（历史笔误），接口失败会抛
        // ReferenceError 挂死路由守卫；改为记录日志，守卫继续走 next() 流程
        console.error("[permission] accountPermission 加载失败:", error);
      });
    } // <- 60s 节流块结束（2026-10-25 风暴修复）
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next();
      NProgress.done();
    } else if (to.path === "/") {
      // console.log("fromfromfromfrom.paht", from.path);
      // console.log("to.paht", to.path);
      // console.log(
      //   "store.getters.leftMenuList[0]",
      //   store.getters.leftMenuList[0]
      // );
      next({ ...store.getters.leftMenuList[0], replace: true });
      NProgress.done();
    } else {
      const hasGetUserPermission = store.getters.init_permission;
      // console.log(
      //   "-------------------------------------------------路由守卫beforeEach",
      //   hasGetUserPermission
      // );
      if (!hasGetUserPermission) {
        routerControl(
          to,
          next,
          api,
          store,
          dynamicRoutes,
          router,
          Message,
          NProgress,
          1
        );
      } else {
        // console.log("dynamicRoutes", dynamicRoutes);
        // console.log("to", to);
        // console.log("fromfromfromfrom.paht", from.path);

        const arr = store.getters.menuTabs;
        const isHasMenuTab = arr.some((menu) => {
          return menu.name === to.name;
        });
        if (isHasMenuTab) {
          arr.forEach((menu) => {
            if (menu.name === to.name) {
              menu.activeRouter = true;
            } else {
              menu.activeRouter = false;
            }
          });
        } else {
          arr.forEach((item) => {
            item.activeRouter = false;
          });
          arr.push({
            title: to.meta.title,
            path: to.path,
            params: to.params,
            name: to.name,
            activeRouter: true,
          });
        }
        if (isInclude(dynamicRoutes, to)) {
          if (havaPermission(store.getters.leftMenuList, to)) {
            store.commit("user/SET_MENU_TABS", [...arr]);
            store.commit("user/SET_ACTIVE_MENU_TAB", to.path);
            next();
          } else {
            Message.warning("暂无权限访问");
            next(false);
            NProgress.done();
          }
        } else {
          Message.warning("页面不存在");
          next(false);
          NProgress.done();
        }
        // console.log('=====================================', to)
        // try {
        // 	// get user info
        // 	// await store.dispatch('user/getInfo')

        // 	next()
        // } catch (error) {
        // 	// remove token and go to login page to re-login
        // 	await store.dispatch('user/resetToken')
        // 	Message.error(error || 'Has Error')
        // 	next(`/login?redirect=${to.path}`)
        // 	NProgress.done()
        // }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      // console.log("无token时，路由跳转");

      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // console.log("测试");
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
